import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import Icon, { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import InternalLink from '~/components/atoms/link/InternalLink'
import { GeneralIconTag } from '~/common/define/icon'

interface Props {
  link: string
  text: string
}

const NavigationMainNew = ({link, text}: Props) => {
  return (
    <InternalLink link={link} className={styles.main__new}>
      <Icon tag={GeneralIconTag.ADD_CROSS} size={IconSize.SMALL} frame={IconFrame.SQUARE} fillColor={IconColor.DARK_GRAY} bgColor={IconColor.WHITE}/>
      <span className={styles.main__new__text}>{text}</span>
    </InternalLink>
  )
}

export default NavigationMainNew